import { t } from "@lingui/macro";

import { BlockSlotIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

export const NoAvailabilityCard = () => {
  return (
    <HStack
      backgroundColor="surface-secondary"
      mx={6}
      height={60}
      gap={3}
      borderRadius="2"
      px={6}
      alignItems="center"
    >
      <BlockSlotIcon color="icon-inverse-subtle" />
      <Text variant="mainSmallSemiBold">{t`No Availability`}</Text>
    </HStack>
  );
};
